import { TableCell, TableRow } from "@mui/material";
import { FC } from "react";

import { IConflict } from "@ryde/shared";

import { RejectedBookingPassengerTableCell } from "./rejected-booking-passenger-table-cell";

interface IRejectedBookingsTableRowProps {
  conflictRow: IConflict;
}

export const RejectedBookingsRow: FC<IRejectedBookingsTableRowProps> = ({
  conflictRow,
}) => {
  return (
    <TableRow>
      <TableCell>{conflictRow.passengerId}</TableCell>
      <RejectedBookingPassengerTableCell passengerId={conflictRow.passengerId}>
        {conflictRow.passengerFullName}
      </RejectedBookingPassengerTableCell>
      <TableCell>{conflictRow?.date}</TableCell>
    </TableRow>
  );
};
